import React, { useState, useEffect } from "react";
import configData from "../appconfig/config.json";
import { Form, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import FundTransferView from "../components/FundTransferView";
import { useHistory } from "react-router-dom";
import { tovalidateExpdate } from "../core/validationRules";
import toFetchIDValue from '../data/IdTypeCheck';
import { toFetchPricingValue } from "../data/pricingNew";
import helper from "../data/Helper";
import Loading from "./Loading";
import { decryptAesText } from "../core/cryptoHelper";


var CryptoJS = require("crypto-js");
let key = CryptoJS.enc.Utf8.parse(configData.CRYPT);
let iv = CryptoJS.enc.Utf8.parse(configData.CRYPT);

const FundTransfer = () => {
  let history = useHistory();

  configData.RefferenceNo = localStorage.getItem("Ref");
  const [showLoading, setShowLoading] = useState(false);

  const [ftdetails, setftdetails] = useState({
    transferFrom: "",
    CreditAcntNO: "",
    CreditAbleAcntNO: "",
    pricing: "",
    transferto: "",
    Nameancnt: localStorage.getItem('CFN'),
    CreditCardnumber: "",
    Amount: null,
  });

  useEffect(() => {

    if (tovalidateExpdate(new Date().getMinutes())) {
      if (configData.RefferenceNo) {
        if (configData.RefferenceNo) {
          const requestBody = {
            //new changes passing details to save at verification
            referenceno: configData.RefferenceNo,
            num: localStorage.getItem("nricval"),
          };
          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "Access-Control-Allow-Headers": "Content-Type",
              "Cache-Control": "no-cache", //for IE issues
              Pragma: "no-cache",
              Authorization: "Maybank" + " " + localStorage.getItem("tkn"),
            },
            body: JSON.stringify(requestBody),
          };

          setShowLoading(true);

          let url = getFTDataURL();

          fetch(url, requestOptions)
            .then(async (response) => {

              setShowLoading(false);
              const data = await response.json();
              if (!data.didError) {
                if (data.model.fields) {
                  if (data.model.fields.Fields) {
                    setftdetails(data.model.fields.Fields);
                    window.scrollTo(0, 0);
                  }
                }
              } else {
              }
            })
            .catch((err) => {
              setShowLoading(false);
              console.log(err);
            });
        }
      } else {
        alert("This session has timed out for your security.Please try again");
        helper.toHomeScreen();
      }
    } else {
      alert("This session has timed out for your security.");
      helper.toHomeScreen();
    }
  }, []);


  if (!ftdetails) {
    return false;
  } else {
    let data = ftdetails.FT1;
    if (data) {
      if (data.CreditAcntNO) {
        configData.checkCCAcntFlag = true;
      } else if (data.CreditAbleAcntNO) {
        configData.checkCAAcntFlag = true;
      }

      if (data.CreditCardnumber) {
        try {
          configData.decrypt = decryptAesText(
            data.CreditCardnumber,
            key,
            { iv: iv }
          );
                    
          configData.decrypt = configData.decrypt.toString(CryptoJS.enc.Utf8);
        } catch (ex) {
          configData.decrypt = data.CreditCardnumber;
          console.log("ex", ex);
        }
      } else {
        configData.decrypt = data.CreditCardnumber;
      }

      if (data.CreditAcntNO) {
        configData.decrypt1 = decryptAesText(data.CreditAcntNO, key, {
          iv: iv,
        });
        configData.decrypt1 = configData.decrypt1.toString(CryptoJS.enc.Utf8);
      } else {
        configData.decrypt1 = data.CreditAcntNO;
      }

      if (data.CreditAbleAcntNO) {
        configData.decrypt2 = decryptAesText(data.CreditAbleAcntNO, key, {
          iv: iv,
        });
        configData.decrypt2 = configData.decrypt2.toString(CryptoJS.enc.Utf8);
      } else {
        configData.decrypt2 = data.CreditAbleAcntNO;
      }

      setftdetails({
        Nameancnt: data.Nameancnt,
        transferFrom: data.transferFrom,
        CreditAcntNO: configData.decrypt1,
        CreditAbleAcntNO: configData.decrypt2,
        pricing: data.pricing,
        transferto: data.transferto,
        Nameancnt: data.Nameancnt,
        CreditCardnumber: configData.decrypt,
        Amount: Number(data.Amount),
      });
    }
  }

  const getFTDataURL = () => {
    let baseUrl = configData.GET_FTDATA_PROD;

    if (configData.SERVER_STATUS === 'SIT') {
      baseUrl = configData.GET_FTDATA_SIT;
    }
    else if (configData.SERVER_STATUS === 'UAT') {
      baseUrl = configData.GET_FTDATA_UAT;
    }
    else {
      baseUrl = configData.GET_FTDATA_PROD;
    }

    return baseUrl;
  }

  const getSaveURL = () => {
    let baseUrl = configData.URL_SAVE_FT_PROD;

    if (configData.SERVER_STATUS === 'SIT') {
      baseUrl = configData.URL_SAVE_FT_SIT;
    }
    else if (configData.SERVER_STATUS === 'UAT') {
      baseUrl = configData.URL_SAVE_FT_UAT;
    }
    else {
      baseUrl = configData.URL_SAVE_FT_PROD;
    }

    return baseUrl;
  }

  const sourceToSuffix = {
    [configData.SRC_CODE_HNW]: "HNW",
    [configData.SRC_CODE_OUTSIDERS]: "MBANKOUTSIDERS",
    [configData.SRC_CODE_CCFT03]: "810203",
    [configData.SRC_CODE_CCFT04]: "810204",
    [configData.SRC_CODE_CCFT05]: "", // BASE
    [configData.SRC_CODE_CCFT06]: "", // BASE
    [configData.SRC_CODE_CCFT]: "",   // BASE
  };
  
  const getPricingCodes = (transferFrom, selectedPricing) => {
    const source = localStorage.getItem("p");

    if (!Object.prototype.hasOwnProperty.call(sourceToSuffix, source)) {
      return { promoCode: "NA", schemeCode: "NA" };
    }

    //const suffix = sourceToSuffix[source] || "BASE";    
    const suffix = sourceToSuffix[source];
    const promo = toFetchPricingValue(suffix, selectedPricing, "PROMO") || "NA";
    const schme = toFetchPricingValue(suffix, selectedPricing, "SCHME") || "NA";

    //console.log(`sc-${suffix} promoCode: ${promo}, schmecode: ${schme}`);

    // Credit Card Account -> PROMO only
    // Creditable Account  -> SCHEME only
    if (transferFrom === "Credit Card Account") {
      return { promoCode: promo, schemeCode: "NA" };
    }

    return { promoCode: "NA", schemeCode: schme };
    
  };

const getSourceCode = () => {
  const sc = localStorage.getItem("p");
  return Object.prototype.hasOwnProperty.call(sourceToSuffix, sc)
    ? sc
    : configData.SRC_CODE_CCFT;
};

  const handleSubmit = (event) => {
    setShowLoading(true);
    if (event.isValid) {
      let countset = 1;
      let transferFrom = event.values.transferFrom;

      configData.acnt_Type =
        transferFrom === "Credit Card Account"
          ? "FTCACC"
          : "FTCACR";
      const { promoCode, schemeCode } = getPricingCodes(transferFrom, event.values.pricing);

      const requestBody = {
        count: countset,
        FT1: {
          transferFrom: transferFrom,
          CreditAcntNO:
            transferFrom === "Credit Card Account"
              ? event.values.CreditAcntNO
              : "",
          CreditAbleAcntNO:
            transferFrom !== "Credit Card Account"
              ? event.values.CreditAbleAcntNO
              : "",
          pricing: event.values.pricing,
          transferto: event.values.transferto,
          transfertoid: toFetchIDValue("BANKDATALIST", event.values.transferto),
          Nameancnt: event.values.Nameancnt,
          CreditCardnumber: event.values.CreditCardnumber,
          Amount: event.values.Amount,
          PRODUCT_TYPE:
            transferFrom === "Credit Card Account"
              ? "FTCACC"
              : "FTCACR",
          PROMO_CODE: promoCode,
          SCHEME_CODE: schemeCode,
          SOURCE_CODE: getSourceCode()
        },
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Headers": "Content-Type",
          "Cache-Control": "no-cache", //for IE issues
          Pragma: "no-cache",
          Authorization: "Maybank" + " " + localStorage.getItem("tkn"),
        },
        body: JSON.stringify(requestBody),
      };

      let url = getSaveURL();

      fetch(
        url +
        "?refno=" +
        configData.RefferenceNo +
        "&prodtype=" +
        configData.acnt_Type,
        requestOptions
      )
        .then(async (response) => {
          setShowLoading(false);
          const data = await response.json();
          if (!data.didError) {
            localStorage.setItem("RefNEW", data.refNo);

            history.push("ReviewDetails");
          } else {
            alert("Something went wrong, please try again");
          }
        })
        .catch((error) => {
          setShowLoading(false);
          alert("Some thing went wrong! please try again");
          helper.toHomeScreen();
        });
    }

  };



  return (
    <div className="container-fluid">
      <div className="row">
        <div className="container mt-5">
          <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
        </div>

        <div className="demo-section k-content dynmicwhitecntr  DynamicFields">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="row example-wrapper">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="card-block"></div>
                <Form
                  onSubmitClick={handleSubmit}
                  initialValues={ftdetails}
                  key={JSON.stringify(ftdetails)}
                  render={(formRenderProps) => (
                    <FormElement>
                      <fieldset className={"k-form-fieldset"}>
                        <div
                          className="row around-xs inputPairelementVisible"
                          style={{ marginTop: "1.5rem" }}
                        >
                          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <legend className={"k-form-legend"}>
                              {configData.HDR_FT_DETAILS}
                            </legend>
                          </div>
                        </div>
                        <FundTransferView />
                        <div
                          className="text-right"
                          style={{ marginTop: "1rem" }}
                        >
                          <Button
                            className="btnMaybank"
                            type={"submit"}
                            primary={true}
                            disabled={!formRenderProps.valid}
                          >
                            {configData.ON_NEXT}
                          </Button>
                        </div>
                      </fieldset>

                      <br></br>
                    </FormElement>
                  )}
                />
                {showLoading && <Loading />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundTransfer;
